<template>
  <div>
    <!-- 生成报表中 -->
    <y-dialog
      :visible="createStatement"
      width="450px"
      title="提示"
      :draggable="false"
      sureText="查看记录"
      cancelText="关闭"
      @comfirm="checkRecord"
      @close="handleDialogClose"
    >
      <div class="create">
        <div style="text-align: center">
          <img
            src="https://cdn-image.yucrm.cn/images/tb-front-platform/images/finish1.png"
            alt=""
            class="size"
          />
        </div>
        <div class="generating">报表生成中...</div>
        <div class="color">生成完成后，在后台管理-导出管理下载报表</div>
      </div>
    </y-dialog>
  </div>
</template>
<script>
export default {
  name: "generate_report",
  props: {
    control: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      createStatement: false,
    };
  },
  mounted: function () {
    this.createStatement = this.control;
  },
  methods: {
    handleDialogClose() {
      this.$emit("transData", false);
    },
    //查看记录
    async checkRecord() {
      window.open(
        `${
          window.location.origin
        }/members-api/yunzhou-common/system-redirect?redirectUrl=/exportManagement?type=2`,
        "_blank"
      );
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/ .el-dialog__header {
  padding-top: 5px;
  border-bottom: 0px;
}
.create {
  width: 100%;
  text-align: center;
  .size {
    width: 100px;
    height: 100px;
  }

  .el-icon-check {
    font-size: 26px;
    color: #fe4d45;
    font-weight: 700;
  }
  .generating {
    font-size: 12px;
    color: #999999;
    // margin: 20px 0 10px 0;
  }
  .color {
    font-weight: 400;
    color: #333333;
    font-size: 14px;
    margin-top: 12px;
  }
}
</style>